import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionTerms() {
 const { t } = useTranslation();
 const navigate = useNavigate();

 useEffect(() => {
 // 滚动到页面顶部
 window.scrollTo(0, 0);
 }, []);

 return (
 <div className="min-h-screen bg-cream-100">
 {/* 顶部导航栏 */}
 <div className="bg-white shadow-sm sticky top-0 z-10">
 <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
 <div className="flex items-center justify-between h-16">
 <button
 onClick={() => navigate(-1)}
 className="flex items-center text-ink-600 hover:text-ink-900 transition-colors"
 >
 <ArrowLeft className="w-5 h-5 mr-2" />
 <span>返回</span>
 </button>
 <h1 className="text-xl font-semibold text-ink-900">Subscription Terms</h1>
 <div className="w-20"></div>
 </div>
 </div>
 </div>

 {/* 主要内容 */}
 <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
 <div className="bg-white rounded-lg shadow-sm p-8">
 {/* 标题部分 */}
 <div className="mb-8 text-center">
 <h1 className="text-3xl font-bold text-ink-900 mb-4">Subscription Terms</h1>
 <p className="text-ink-600">
 This document outlines the terms and conditions for subscribing to our services. Please read carefully to understand your rights and obligations.
 </p>
 </div>

 {/* 公司信息 */}
 <div className="mb-8 p-6 bg-cream-100 rounded-lg">
 <h2 className="text-xl font-semibold text-ink-900 mb-4">Company Information</h2>
 <div className="space-y-2 text-ink-700">
 <p><span className="font-medium">Company Name:</span> SmartTool AI Solutions Limited</p>
 <p><span className="font-medium">Brand Name:</span> 紫刀AI</p>
 <p><span className="font-medium">Company Website:</span> <a href="https://ai2you.org/" className="text-accent-500 hover:text-accent-600">https://ai2you.org/</a></p>
 <p><span className="font-medium">Contact Email:</span> <a href="mailto:support@ai2you.org" className="text-accent-500 hover:text-accent-600">support@ai2you.org</a></p>
 <p className="text-sm text-ink-600 mt-4">Last Updated: May 15, 2025</p>
 </div>
 </div>

 {/* 订阅条款内容 */}
 <div className="space-y-8">
 {/* I. SUBSCRIPTION */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">I. SUBSCRIPTION</h2>
 <p className="text-ink-700 mb-4">
 <a href="https://ai2you.org/" className="text-accent-500 hover:text-accent-600">https://ai2you.org/</a> (the "Website") is provided by SmartTool AI Solutions Limited ("we," "us" or "our"). We offer both free and premium services. Once you start using the Website, you will have access to its basic features.
 </p>
 <p className="text-ink-700 mb-4">
 Access to unlimited features requires paid subscriptions. The full list of features and pricing are provided on the Website. You can choose different subscription options. Prices are in U.S. dollars and may vary in countries other than the U.S. You will have all the necessary information about your subscription plan on the Website before the purchase.
 </p>
 <p className="text-ink-700">
 Your subscription will be automatically renewed within 24 hours before the current subscription ends. Please see Section IV. CANCELLATION to understand how to cancel your subscription.
 </p>
 </section>

 {/* II. FREE TRIAL */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">II. FREE TRIAL</h2>
 <p className="text-ink-700 mb-4">
 You may have an opportunity to try Premium options for a limited time or with a limited number of requests. Details of any free trial will be specified on our pricing page.
 </p>
 <p className="text-ink-700">
 To continue using premium features after your trial period ends, you should choose one of the paid subscriptions provided on the Website.
 </p>
 </section>

 {/* III. PAYMENT METHODS */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">III. PAYMENT METHODS</h2>
 <p className="text-ink-700 mb-4">
 Payment is processed through our secure payment system. You can pay for your subscription using a debit or credit card or via other payment methods available on our Website.
 </p>
 <p className="text-ink-700 mb-4">
 Payment will be charged to the payment method you provided at the time of purchase. You authorize us to charge the applicable subscription fees to the payment method that you have chosen.
 </p>
 <p className="text-ink-700">
 For subscriptions purchased through mobile app stores (such as Apple App Store or Google Play), the respective store's payment terms will apply.
 </p>
 </section>

 {/* IV. CANCELLATION */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">IV. CANCELLATION</h2>
 <p className="text-ink-700 mb-4">
 Subscriptions are managed by you. You can manage your subscription through your account settings on our Website.
 </p>
 <p className="text-ink-700 mb-4">
 If you want to cancel your subscription, the cancellation will apply only after expiration of the active subscription period. No cancellation is allowed for the remaining part of the active subscription period.
 </p>
 
 <div className="space-y-4">
 <div>
 <h3 className="text-lg font-medium text-ink-800 mb-2">Website Purchases:</h3>
 <p className="text-ink-700">
 You may cancel your subscription purchased on the Website by clicking the "Cancel Subscription" button on your profile page. To avoid being charged, cancel your subscription before the end of the active subscription period.
 </p>
 </div>

 <div>
 <h3 className="text-lg font-medium text-ink-800 mb-2">App Store Purchases:</h3>
 <p className="text-ink-700">
 For subscriptions purchased through mobile app stores, please refer to the respective store's cancellation policies and manage your subscription through your account with that store.
 </p>
 </div>
 </div>

 <p className="text-ink-700 mt-4">
 You may also cancel your subscription by contacting us via email at <a href="mailto:support@ai2you.org" className="text-accent-500 hover:text-accent-600">support@ai2you.org</a> or through our "Contact Us" form available on the Website. To avoid being charged, cancel your subscription before the end of the current subscription period.
 </p>
 </section>

 {/* V. REFUNDS */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">V. REFUNDS</h2>
 <p className="text-ink-700 mb-4">
 To address all issues related to refunds with respect to subscription(s) purchased on the Website, we have developed a Refund Policy that constitutes an integral and inalienable part of the present Subscription Terms. Please examine our Refund Policy carefully to know the terms and conditions regarding refund eligibility requirements, process, exceptions, and limitations that may apply.
 </p>
 <p className="text-ink-700">
 For subscriptions purchased through mobile app stores, refund policies of the respective stores will apply.
 </p>
 </section>

 {/* VI. CHARGEBACKS/DISPUTES */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">VI. CHARGEBACKS/DISPUTES</h2>
 <p className="text-ink-700 mb-4">
 If, at any time, you initiate a chargeback or otherwise reverse any payment of applicable subscription fees in your account, we may disable or terminate your account immediately at our sole discretion for the breach of your payment obligations hereunder.
 </p>
 <p className="text-ink-700">
 We reserve the right to dispute any chargeback received, including by providing the relevant financial institution with any information proving that the payment in question was authorized by the user responsible for such chargeback.
 </p>
 </section>

 {/* VII. CHANGES */}
 <section>
 <h2 className="text-2xl font-semibold text-ink-900 mb-4">VII. CHANGES</h2>
 <p className="text-ink-700 mb-4">
 We reserve the right to modify, terminate, or otherwise amend our offered subscription plans at any time. We will give you reasonable notice of any such changes by posting them on or through the Website and/or by sending you an email notification, or in other prominent ways. If you do not wish to pay the new fees, you can cancel the applicable subscription prior to the change going into effect.
 </p>
 </section>

 {/* 联系信息 */}
 <section className="border-t pt-8">
 <div className="bg-accent-50 p-6 rounded-lg">
 <h3 className="text-lg font-medium text-ink-900 mb-3">Contact Us</h3>
 <p className="text-ink-700 mb-4">
 If you have any questions about these Subscription Terms, please contact us via email at <a href="mailto:support@ai2you.org" className="text-accent-500 hover:text-accent-600 font-medium">support@ai2you.org</a>.
 </p>
 <p className="text-sm text-ink-600">
 Last Updated: May 15, 2025
 </p>
 </div>
 </section>
 </div>
 </div>
 </div>
 </div>
 );
} 